import { render, staticRenderFns } from "./demandPublishSetting.vue?vue&type=template&id=f082dc84&scoped=true&"
import script from "./demandPublishSetting.vue?vue&type=script&lang=js&"
export * from "./demandPublishSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f082dc84",
  null
  
)

export default component.exports